<template>
  <div>

    <!-- Sizes your content based upon application components -->
    <v-main>
        <!-- Provides the application the proper gutter -->
        <v-container fluid>
          <div v-if="!isVerifiedUser" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg dark:bg-yellow-200 dark:text-yellow-800" role="alert">
            <span class="font-medium">New user information,</span> we have sent you a <span class="font-medium">verification email</span>, please check your email inbox to <span class="font-medium">verify</span> your account before try to use your credits.
          </div>

        <!-- If using vue-router -->
        <router-view></router-view>
        </v-container>
    </v-main>

    <v-app-bar
      elevation="0"
      fixed
      app
      clipped-left
    >

      <nav class="w-full pt-1 pb-2 shadow-md bg-white border-gray-100 dark:bg-gray-800 dark:border-gray-700 border-b-2">
        <div class="flex flex-wrap justify-start">
          <div class="flex flex-wrap flex-row">
              <a @click="goToHomePage">
                <div class="flex justify-center m-auto">
                  <img class="w-8 h-8 m-auto ml-4 mr-2" src="../assets/images/robot.png"/>
                  <h3 class="mt-2" style="font-weight:bold; font-family:'Signika', sans-serif; font-size:30px; color:#333333;">
                    <strong>Simple<span style="color:#ff5c8d">i</span>sh</strong>
                  </h3>
                </div>
              </a>
            <div class="flex flex-wrap justify-end md:hidden">
            <button @click="drawer = !drawer" data-collapse-toggle="mobile-menu" type="button" class="inline-flex justify-center items-center ml-3 mr-3 text-gray-400 rounded-lg md:hidden hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-300 dark:text-gray-400 dark:hover:text-white dark:focus:ring-gray-500" aria-controls="mobile-menu-2" aria-expanded="false">
              <span class="sr-only">Open main menu</span>
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
              <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
            </div>

          <div class="flex w-full md:block md:w-auto" :class="!isMenuOpen ? 'hidden' : ''" id="mobile-menu">
              <ul class="flex w-2/3 flex-col md:flex-row mt-2 md:space-x-4 md:mt-0 md:text-sm md:font-bold">
                <li>
                  <button @click="isDropdownOpened = !isDropdownOpened" id="dropdownNavbarLink" data-dropdown-toggle="dropdownNavbar" class="flex justify-between items-center py-3 pr-4 pl-3 w-full font-medium text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-gray-400 dark:hover:text-white dark:focus:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent">Use Cases <svg class="ml-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg></button>
                  <!-- Dropdown menu -->
                  <div id="dropdownNavbar" class="absolute z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600" :class="isDropdownOpened ? '' : 'hidden'">
                      <ul class="px-0 divide-y" aria-labelledby="dropdownLargeButton">
                        <li>
                          <a @click="goToPersonalUse" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('personal_use_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToEcommerce" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('e_commerce_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToPhotography" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('photography_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToMarketing" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('marketing_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToNews" class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('news_&_media_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToCarDealers" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('car_dealers_nav')}}</a>
                        </li>
                        <li>
                          <a @click="goToDeveloperUse" class="block py-4 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('developers_nav')}}</a>
                        </li>
                      </ul>
                  </div>
                </li>
                <li>
                  <a @click="goToApiDocumentation" class="block py-3 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 dark:hover:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"><span v-html="$t('api')"></span></a>
                </li>
                <li>
                  <a @click="goToPricing" class="block py-3 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 dark:hover:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"><span v-html="$t('pricing')"></span></a>
                </li>
                <li v-if="loggedIn" class="md:hidden">
                  <a @click="logout" class="block py-3 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 dark:hover:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"><span v-html="$t('logout')"></span></a>
                </li>
              </ul>
          </div>
          <div v-if="loggedIn" class="flex w-full md:block md:w-auto justify-end" :class="!isMenuOpen ? 'hidden' : ''" id="mobile-menu2">
              <ul class="flex flex-col md:flex-row justify-end mt-2 mr-6 md:space-x-4 md:mt-0 md:text-sm md:font-bold">
                <li>
                  <button @click="goToUpload" type="button" class="text-black bg-white border-blue-300 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Remove Background</button>
                </li>
                <li>
                  <button @click="isDropdownUserMenuOpened = !isDropdownUserMenuOpened" id="dropdownNavbarLink" data-dropdown-toggle="dropdownNavbar" class="flex justify-between items-center py-3 w-full font-medium text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-gray-400 dark:hover:text-white dark:focus:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg></button>
                  <!-- Dropdown menu -->
                  <div id="dropdownNavbarUserMenu" class="absolute z-10 w-22 right-6 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600" :class="isDropdownUserMenuOpened ? '' : 'hidden'">
                      <ul class="px-0 divide-y" aria-labelledby="dropdownLargeButton">
                        <li>
                          <span class="block py-4 px-4 text-sm cursor-default text-gray-700 dark:text-gray-400 dark:hover:text-white">{{userInfo.email}}</span>
                        </li>
                        <li >
                          <a @click="logout" class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white">{{$t('logout')}}</a>
                        </li>
                      </ul>
                  </div>
                </li>
              </ul>
          </div>
          <div v-else class="flex w-full md:block md:w-auto justify-end" :class="!isMenuOpen ? 'hidden' : ''" id="mobile-menu2">
              <ul class="flex flex-col md:flex-row justify-end mt-2 mr-6 md:space-x-4 md:mt-0 md:text-sm md:font-bold">
                <li v-if="!loggedIn" class="flex flex-wrap justify-end">
                  <button v-if="!loggedIn" @click="goToLogin" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Login</button>
                  <button v-if="!loggedIn" @click="goToRegister" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Get Started With A Free Account</button>
                </li>
              </ul>
          </div>
          </div>
        </div>
      </nav>
      
    </v-app-bar>

    <div>
      <v-navigation-drawer
        v-model="drawer"
        fixed
        app
        clipped
      >
        <v-list
          dense
        >
          <v-list-item-group
            v-model="sideMenuSelected"
            active-class="blue--text"
          >
            <v-list-item v-for="(item, index) in items" :key="index" link @click="goToPage(item, index)">
              <div :v-html="item.icon">
              </div>
              <v-list-item-content>
                  <v-list-item-title>
                    <div class="flex text-sm px-1 py-1 text-center  items-center mr-2">
                      <span class="mr-2" v-html="item.icon"></span>
                      <span>
                        <strong>{{ item.title }}</strong>
                      </span>
                    </div>
                  </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <div class="md:hidden">
              <v-list-item @click="logout">
                <v-list-item-content>
                    <v-list-item-title>
                        <div class="flex text-sm px-1 py-1 text-center items-center mr-2">
                        <span class="mr-2"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg></span>
                        <span>
                          <strong>Logout</strong>
                        </span>
                      </div>
                    </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </div>
    
    </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
  name: 'DashboardPage',

  components: {
  },

  data () {
      return {
        isVerifiedUser: true,
        tab: null,
        items: [
          { title: 'Credit Details', icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>', route: '/credit-details' },
          { title: 'Api Credentials', icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path></svg>', route: '/client-details' },
          { title: 'Billings & Payments', icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg>', route: '/user-billings' },
          { title: 'Your Temporary Files', icon: '<svg class="w-6 h-6 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"></path></svg>', route: '/files' },
          { title: 'Refer To A Friend', icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>', route: '/referral-details' },
        ],
        open: false,
        drawer: true,
        sideMenuSelected: 0,
        isMenuOpen: false,
        isDropdownOpened: false,
        isDropdownUserMenuOpened: false
      }
    },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    userInfo() {
      return this.$store.state.auth.user;
    },
    currentRoutePath() {
      return this.$route.path;
    }
  },

  created() {
    if(window.innerWidth <= 760)
    {
      this.drawer = false;
    }

    this.sideMenuSelected = this.items.findIndex(x => x.route === this.currentRoutePath);

    this.isUserVerified();
  },
  methods: {
    goToUpload(selectedFile, method) {
      if(this.$route.name !== 'UploadPage')
      {
        this.$router.push({
        name: 'UploadPage',
        params: {
          selectedFile : selectedFile,
          method : method
          }
        });
      }
    },
    isUserVerified(){
      AuthService.isUserVerified().then(
        response => {
          this.isVerifiedUser = response.data
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
            this.loading = false;
        }
      );
    },
    goToHomePage() {
      this.$router.push('/');
    },
    goToPricing() {
      this.$router.push('/pricing');
    },
    goToApiDocumentation() {
      this.$router.push('/api-documentation');
    },
    goToPersonalUse() {
      this.$router.push('/personal-use');
    },
    goToEcommerce() {
      this.$router.push('/e-commerce');
    },
    goToPhotography() {
      this.$router.push('/photography');
    },
    goToMarketing() {
      this.$router.push('/marketing');
    },
    goToNews() {
      this.$router.push('/news');
    },
    goToCarDealers() {
      this.$router.push('/car-dealers');
    },
    goToDeveloperUse() {
      this.$router.push('/developer-use');
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToRegister() {
      this.$router.push('/register');
    },
    goToContact() {
      this.$router.push('/contact-form');
    },
    goToRefunds() {
      this.$router.push('/refunds');
    },
    goToTermOfService() {
      this.$router.push('/term-of-service');
    },
    goToPrivacyPolicy() {
      this.$router.push('/privacy-policy');
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
    toggle() {
      this.open = !this.open;
    },
    goToPage(item){
      this.$router.push({ path: item.route });
    }
  }
}
</script>
